<template>
  <div class="home">
    <p style="margin-left: 300px;margin-top: 150px">photon</p>
    <p style="margin-left: 300px;margin-top: 0px">ranch</p>
    <p style="margin-left: 300px;margin-top: 0px">code</p>
    <p style="margin-left: 300px;margin-top: 0px">documentation</p>
  </div>
</template>

<script>

export default {
  name: 'home',
}
</script>

<style lang="scss">
.home {
padding: 5em;
}
</style>
